import { getStreetOrientationForHalfEdge } from "building-common/planarGraph/planarGraphPerimeterInfo";
import type { StreetOrientation } from "building-types/building/streetOrientationTypesEnum";
import type { RoomEdgeHandle } from "building-types/handles/docEntityHandleTypes";
import type { PlanarGraphPerimeterInfo } from "building-types/planarGraphs/planarGraphPerimeterInfo";
import type { SolidWallSide, Wall } from "building-types/walls/wallTypes";
import { getWallPath } from "building-types/walls/wallUtils";
import { planarGraphAdjacentHalfEdge } from "geom/planarGraph";

export function roomEdgeHandleFromWallSide(side: SolidWallSide): RoomEdgeHandle | undefined {
  const wallRoom = side.descriptor?.wallRoom;
  const roomHandle = wallRoom?.room?.roomHandle;
  const roomEdgeIndex = wallRoom?.roomEdgeIndex;
  if (!roomHandle || roomEdgeIndex === undefined) {
    return undefined;
  }

  return {
    type: "EDGE",
    parent: roomHandle,
    shapeId: "outline",
    edgeId: roomEdgeIndex,
  };
}

export function getWallStreetOrientation(
  wall: Wall,
  perimeterInfo: PlanarGraphPerimeterInfo | undefined,
): StreetOrientation | undefined {
  const halfEdgeIndex = getWallPath(wall).halfEdgeIndex;
  return (
    getStreetOrientationForHalfEdge(halfEdgeIndex, perimeterInfo) ??
    getStreetOrientationForHalfEdge(planarGraphAdjacentHalfEdge(halfEdgeIndex), perimeterInfo)
  );
}
